import React from 'react';

export const Loader = ({ small, smallest, xxs }) => {
  return (
    <div className={`flex items-center justify-center ${!small && !smallest && !xxs ? 'h-72' : ''}
     ${small ? 'h-20' : ''} ${smallest ? 'h-8' : ''} ${xxs ? 'h-5' : ''}`}
    >
      <span className={`loader ${small ? 'loader-small' : ''} ${smallest ? 'loader-xs' : ''} ${xxs ? 'loader-xxs' : ''}`} />
    </div>
  );
};
